import React from 'react';
import {useHistory} from 'react-router-dom';
import helpIcon from '../../../imgs/helpicon.svg';
import { useDispatch } from "react-redux"
import logIcon from '../../../imgs/logouticon.svg';
import { logoutApp } from '../../../redux/actions/auth';

const MoreMenu = () => {
  const history = useHistory();
  const dispatch = useDispatch() 

  const handleLogout = async () => {
    dispatch(logoutApp());
  };

  return (
    <div className="more-menu">
      <a className="sidebar-links active">
        <span>
          <img src={helpIcon} alt="logo" />
        </span>
        Help
      </a>
      <a className="sidebar-links active" onClick={() => handleLogout()}>
        <span>
          <img src={logIcon} alt="logo" />
        </span>
        Log out
      </a>
    </div>
  );
};

export default MoreMenu;
